import React from "react";
import { Button, Modal, Alert } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import moment from "moment";
import immutable from "immutable";
import { browserHistory, Redirect } from "react-router";

import Announcement from "./shared/announcement.jsx";
import PendingDocuments from "./shared/pending-documents.jsx"

import AccountVerify from "./mfa/account-verify.jsx";
import CommonLink from "./shared/link.jsx";
import InstantMessage from "./shared/instant-message.jsx";
import util from "../lib/util.js";
import DynamicContent from "../lib/components/dynamic-content.jsx";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuItems: [],
            showDialog: false,
            peopleEmail: "",
            country: "",
            currentHref: "",
            optOut: false,
            optOutDialog: {
                show: false,
                type: ""
            },
            goGreenDialog: {
                show: false,
                callback: null
            },
            goGreenTaxDialog: {
                show: false,
                optOut: "",
                callback: null
            },
        }

        this.loadAnnouncement = this.loadAnnouncement.bind(this);
        this.loadCountBadge = this.loadCountBadge.bind(this);
        this.handleSensitiveModule = this.handleSensitiveModule.bind(this);
        this.optInPayStatement = this.optInPayStatement.bind(this);
        this.optInTaxStatement = this.optInTaxStatement.bind(this);
    }

    componentDidMount() {           
        let appRoot = context.appRoot().substring(1) + '/';
        let self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.vm()
            .get("menu")
            .then(function (res) {
                context.message({ show: false });
                let data = res.data;

                // TODO: no need for codes below when all screens are converted to ReactJS
                /*
                for (let i=0; i<data.length; i++) {
                    if (data[i].href.indexOf(appRoot) > -1)
                        data[i].href = data[i].href.replace(appRoot, '');
                    else
                        data[i].href = `../../${data[i].href}`;
                }*/

                self.setState({ menuItems: data });
                self.loadCountBadge(data);
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });

        if (window.location.href.indexOf('?sensitiveHref=') > -1) {
            var href = util.getQueryStringValue('sensitiveHref');
            self.handleSensitiveModule(href);
        }
    }

    loadCountBadge(menuItems) {

        let self = this;
        for (let i = 0; i < menuItems.length; i++) {
            let route = '';

            if (menuItems[i].href.indexOf('people/tc-changed') > -1){
                route = `count-unconfirmed-tc-changes/people`;
            }                
            else if(menuItems[i].href.indexOf('people/document') > -1){
                route = `get-pending-documents-count`;
            }
            else
                continue;

            ajax.api().get(route)
                .then(function (res) {
                    menuItems[i].badgeCount = res.data;
                    self.setState({ menuItems: menuItems });
                })
                .catch(function (err) {
                    let data = err.response.data;
                    let message = data.exceptionMessage || data.message;
                    console.log(`Error calling ${route}: ${message}`);
                    return '';
                });
        }
    }

    loadAnnouncement() {
        let self = this;
        let vm = self.state;
        context.message({ show: true, type: "loading", message: "Loading. Please wait..." });
        ajax.api().get("supervisor/get-delegates")
            .then(function (res) {
                self.setState({ delegateList: res.data });
                context.message({ show: false });
            })
            .catch(function (err) {
                console.log(err);
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }



    /**
     * @private
     * @param {Boolean} optIn 
     */
    optInPayStatement(optIn) {
        const self = this;
        var payload = {
            optIn: optIn ? "Y" : "N"
        };

        ajax.api().post("online-pay-statement-optin", payload)
            .then(res => {
                if (optIn) self.state.goGreenDialog.callback();
            })
            .catch(err => {
                console.log(err);
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            })
    }

    /**
     * @private
     * @param {Boolean} optIn 
     */
    optInTaxStatement(optIn) {
        const self = this;
        var payload = {
            optIn: optIn ? "Y" : "N"
        };

        ajax.api().post("online-tax-statement-optin", payload)
            .then(res => {
                if (optIn) self.state.goGreenTaxDialog.callback();
            })
            .catch(err => {
                console.log(err);
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            })
    }

    handlePayStatementOptinOut(href) {
        let self = this;
        let tokenExpired = false;
        let userAuthenticated = false;
        let optout = false;


        const challenge = (function () {
            context.message({ show: true, type: "loading", message: "Loading. Please wait..." });

            ajax.api()
                .get("people/user-challenge")
                .then(function (res) {
                    const result = res.data;
                    tokenExpired = result.tokenExpired;
                    userAuthenticated = result.userPrevAuthenticated;

                    if (tokenExpired) {
                        browserHistory.push(context.routeUrl('login'));
                    }
                    else if (userAuthenticated) {
                        browserHistory.push(context.routeUrl(href));
                    }
                    else {
                        self.setState({
                            showDialog: !userAuthenticated,
                            peopleEmail: result.peopleEmail,
                            currentHref: href
                        });
                    }
                    context.message({ show: false, });
                })
                .catch(function (err) {
                    let data = err.response.data;
                    console.log(data);
                    context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
                });
        });

        const askGoGreen = function () {
            const newState = immutable.fromJS(self.state).toJS();
            newState.goGreenDialog.show = true;
            newState.goGreenDialog.callback = challenge;
            self.setState(newState);
        }

        const showOptOut = function () {
            const newState = immutable.fromJS(self.state).toJS();
            newState.optOutDialog.show = true;
            newState.optOutDialog.type = "Pay";
            self.setState(newState);
        }

        const checkPayStubOptIn = function () {
            return new Promise((resolve, reject) => {
                ajax.api().get("online-pay-statement-optin")
                    .then(res => {
                        resolve((res.data || "").toUpperCase());
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        }

        checkPayStubOptIn()
            .then((/** @type {String} */option) => {
                switch (option) {
                    case "Y":
                        challenge.bind(self)();
                        break;
                    case "N":
                        askGoGreen.bind(self)();
                        //showOptOut.bind(self)();
                        break;
                    default:
                        askGoGreen.bind(self)();
                        break;
                }
            })
            .catch(err => {
                console.log(err);
                let data = err.response.data;
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            });;
    }

    handleTaxOptinOut(href) {
        let self = this;
        let tokenExpired = false;
        let userAuthenticated = false;
        let optout = false;


        const challenge = (function () {
            context.message({ show: true, type: "loading", message: "Loading. Please wait..." });

            ajax.api()
                .get("people/user-challenge")
                .then(function (res) {
                    const result = res.data;
                    tokenExpired = result.tokenExpired;
                    userAuthenticated = result.userPrevAuthenticated;

                    if (tokenExpired) {
                        browserHistory.push(context.routeUrl('login'));
                    }
                    else if (userAuthenticated) {
                        browserHistory.push(context.routeUrl(href));
                    }
                    else {
                        self.setState({
                            showDialog: !userAuthenticated,
                            peopleEmail: result.peopleEmail,
                            currentHref: href
                        });
                    }
                    context.message({ show: false, });
                })
                .catch(function (err) {
                    let data = err.response.data;
                    console.log(data);
                    context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
                });
        });

        const askGoGreenTax = function (optOut, country) {
            const newState = immutable.fromJS(self.state).toJS();
            newState.goGreenTaxDialog.show = true;
            newState.goGreenTaxDialog.optOut = optOut;
            newState.country = country;
            newState.goGreenTaxDialog.callback = challenge;

            self.setState(newState);
        }

        const showOptOutTax = function () {
            const newState = immutable.fromJS(self.state).toJS();
            newState.optOutDialog.show = true;
            newState.optOutDialog.type = 'Tax';
            self.setState(newState);
        }

        const checkTaxStatementOptIn = function () {
            return new Promise((resolve, reject) => {                
                ajax.api().get("online-tax-statement-optin")
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        }

        checkTaxStatementOptIn()
            .then((res) => {
                console.log("debug"); 
                var option = (res.optOut || "").toUpperCase();
                var country = (res.country || "").toUpperCase();

                switch (option) {
                    case "Y":
                        challenge.bind(self)();
                        break;
                    case "N":
                        askGoGreenTax.bind(self)(option, country);
                        //showOptOutTax.bind(self)();
                        break;
                    default:
                        askGoGreenTax.bind(self)(option, country);
                        break;
                }
            })
            .catch(err => {
                console.log(err);
                let data = err.response.data;
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            });;
    }

    /**
     * 
     * @param {string} href 
     */
    handleSensitiveModule(href) {
        console.log('handleSensitiveModule(' + href + ')');
        const challenge = function () {
            alert('Sensitive Info');
        }
        if (href.indexOf('paystub') > -1) {
            this.handlePayStatementOptinOut(href);
        } else if (href.indexOf('taxdocs') > -1) {
            this.handleTaxOptinOut(href);
        } else challenge();
    }

    render() {
        const self = this;

        const menuItems = this.state.menuItems;
        const menuPeople = menuItems.filter(item => item.roleAccess == 1);
        const menuSupervisor = menuItems.filter(item => item.roleAccess == 2);
        const menuPayrollAdmin = menuItems.filter(item => item.roleAccess == 3);
        const menuMarketing = menuItems.filter(item => item.roleAccess == 4);
        const menuHR = menuItems.filter(item => item.roleAccess == 5);
        const menuExec = menuItems.filter(item => item.roleAccess == 6);

        const errorMsg = this.props.location.query.msg ? <Alert bsStyle="danger">{this.props.location.query.msg}</Alert> : null;
        const colorGreen = {color: "#59d037"};

        return (
            <div className="container" style={{ width: '100%', padding: '0px' }}>

                {/* header when displayed in desktop */}
                <section className="ap-l-section ap-section-hero home hidden-sm hidden-xs">
                    <div className="row">
                        <div className="col-md-3 col-md-offset-3 col-lg-3 col-lg-offset-3">
                            <h4>
                                WELCOME TO YOUR
                            </h4>
                            <br />
                            <h2>
                                <em style={{ fontFamily: ["Chronicle Text G1", "Chronicle Text G1 A", "Chronicle Text G1 B"] }}>
                                    ACTion Portal
                                </em>
                            </h2>
                        </div>
                        <div className="col-md-6 col-lg-6 small-text-center">
                            <img src={context.url("images", "home-hero-img.jpg")} />
                        </div>
                    </div>
                </section>

                {/* header when displayed in mobile */}
                <section className="ap-l-section ap-section-hero hidden-md hidden-lg">
                    <div className="row">
                        <div className="col-sm-12 col-xs-12 center" style={{ "textAlign": "center" }}>
                            <h4>
                                WELCOME TO YOUR
                            </h4>
                            <h2 style={{ "marginTop": "0px", "fontWeight": "bold" }}>
                                <em style={{ fontFamily: ["Chronicle Text G1 A", "Chronicle Text G1 B"] }}>
                                    ACTion Portal
                                </em>
                            </h2>
                        </div>
                    </div>
                </section>

                <section className="ap-l-section light dark-bar">
                    <div className="row hidden-sm hidden-xs">
                        <div className="col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3">
                            <p>
                                This site was created to make it easy for you to report your time while on assignment and to provide quick access to information and resources related to your pay and benefits, work assignments, and professional development.
                            </p>
                        </div>
                    </div>
                    <div className={errorMsg ? "row" : "hidden"}>
                        <div className="col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-sm-12 col-xs-12">
                            {errorMsg}
                        </div>
                    </div>                    
                    <div className="row">
                        <div className="col-md-3 col-md-offset-3 col-lg-3 col-lg-offset-3 col-sm-12 col-xs-12">
                            <div className="ap-menu-panel">
                                <h4 className="hidden-sm hidden-xs">
                                    <em>Here are a few of the resources available to you through this portal:</em>
                                </h4>
                                <div className={menuPeople.length ? "" : "ap-hidden"}>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuPeople.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    {
                                                        item.isSensitive ?
                                                            <a href="#" onClick={() => this.handleSensitiveModule(item.href)}><i className={item.iconClass}><span className="notification-count">{item.badgeCount}</span></i>{item.title}</a> :
                                                            <a href={item.href} ><i className={item.iconClass}><span className="notification-count">{item.badgeCount}</span></i>{item.title}</a>
                                                    }

                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className={menuSupervisor.length ? "" : "ap-hidden"}>
                                    <span className="ap-menu-block-header">Supervisor</span>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuSupervisor.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    <a href={item.href}><i className={item.iconClass}></i>{item.title}</a>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className={menuPayrollAdmin.length ? "" : "ap-hidden"}>
                                    <span className="ap-menu-block-header">Payroll Admin</span>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuPayrollAdmin.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    <a href={item.href}><i className={item.iconClass}></i>{item.title}</a>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className={menuMarketing.length ? "" : "ap-hidden"}>
                                    <span className="ap-menu-block-header">Marketing</span>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuMarketing.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    <a href={item.href}><i className={item.iconClass}></i>{item.title}</a>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className={menuHR.length ? "" : "ap-hidden"}>
                                    <span className="ap-menu-block-header">Human Resources</span>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuHR.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    <a href={item.href}><i className={item.iconClass}></i>{item.title}</a>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className={menuExec.length ? "" : "ap-hidden"}>
                                    <span className="ap-menu-block-header">Executive</span>
                                    <ul className="ap-menu-block-grid">
                                        {
                                            menuExec.map(item =>
                                                <li className="ap-menu-block-icon" key={item.href}>
                                                    <a href={item.href}><i className={item.iconClass}></i>{item.title}</a>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12">
                            {/*<div className="row">*/}
                            {/*    <InstantMessage pageName="covid-19" />*/}
                            {/*</div>*/}
                            <div className="row">
                                <PendingDocuments />
                            </div>
                            <div className="row">
                                <Announcement />
                            </div>
                            <div className="row">
                                <CommonLink />
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    {this.state.showDialog ? <AccountVerify peopleEmail={this.state.peopleEmail} showDialog={this.state.showDialog} currentHref={this.state.currentHref} /> : null}
                </section>

                <Modal show={this.state.optOutDialog.show} backdrop='static'>
                    <Modal.Header>
                        <h3>Opted-Out Message</h3>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <p>
                            You are receiving this message because you have previously opted out from accessing your {this.state.optOutDialog.type} Statement in the ACTionPortal.
                            To opt-in, please contact HR.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='pull-left' style={{ width: 150 }}
                            onClick={() => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.optOutDialog.show = false;
                                self.setState(newState);
                            }}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.goGreenDialog.show} backdrop='static'>
                    <Modal.Header>
                        <h3>Pay Statements - Go Paperless. <span style={colorGreen}>Go Green</span></h3>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <p>
                            You can now access your pay statements online and stop receiving paper copies of your statements.
                            Your payment method will stay the same. You may go back to receiving paper statements at any time by contacting
                            Human Resources at (800) 270-9120 or by emailing to <a href="mailto:hrnotification@ain1.com">hrnotification@ain1.com</a>
                        </p>

                        <table cellPadding="0" style={{ border: "0px" }}>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInPayStatementYes' name='optInPayStatement' type='radio' radioGroup='optOutPayStatement' defaultChecked />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I want to access my Pay Statements online only. Pay Statements can be downloaded and printed whenever you want,
                                    24/7, including from your computer at work.
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input name='optInPayStatement' type='radio' radioGroup='optOutPayStatement' />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I prefer to receive paper Pay Statements only. I do not want to access my Pay Statements online.
                                </td>
                            </tr>
                        </table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='pull-left' style={{ width: 150 }}
                            onClick={evt => {
                                //if ($('#optInPayStatementYes').isChecked()) self.state.goGreenDialog.callback();
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenDialog.show = false;
                                self.setState(newState);
                                self.optInPayStatement($('#optInPayStatementYes').prop("checked"));
                            }}>Submit</Button>
                        <Button className='pull-right' style={{ width: 150 }}
                            onClick={() => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenDialog.show = false;
                                self.setState(newState);
                            }}>Cancel</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.goGreenTaxDialog.show && (this.state.country == "USA")} backdrop='static'>
                    <Modal.Header>
                        <h3>W2 Statements - Go Paperless. <span style={colorGreen}>Go Green</span></h3>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <p>
                            When W2s and 1095Cs are created and issued at the end of January each year,
                            you can now access your W2/1095C combined statements online and stop receiving
                            a mailed paper W2/1095C statement.  You will have the convenience to access them
                            at any time once they are posted.
                        </p>

                        <table cellPadding="0" style={{ border: "0px" }}>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutW2Yes' name='optInOutW2' type='radio' radioGroup='optInOutW2' value='Y' defaultChecked={this.state.goGreenTaxDialog.optOut != 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I want to access my W2 and 1095C statements online only and opt out of receiving paper W2 and 1095C by mail.
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutW2No' name='optInOutW2' type='radio' radioGroup='optInOutW2' value='N' defaultChecked={this.state.goGreenTaxDialog.optOut === 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I prefer to continue receiving paper W2 and 1095C by mail and I do not wish to access my W2 and 1095C statements online.*
                                </td>
                            </tr>
                        </table>
                        <p><em>
                            *If you change your mind, please return to this portal and click on Tax Statement icon to opt out of receiving paper W2 and 1095C by mail and get your W2/1095C electronically online.
                        </em></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='pull-left' style={{ width: 150 }}
                            onClick={evt => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                                self.optInTaxStatement($('#optInOutW2Yes').prop("checked"));
                            }}>Submit</Button>
                        <Button className='pull-right' style={{ width: 150 }}
                            onClick={() => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                            }}>Cancel</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.goGreenTaxDialog.show && (this.state.country == "CAN")} backdrop='static'>
                    <Modal.Header>
                        <h3>T4 Statements - Go Paperless. <span style={colorGreen}>Go Green</span></h3>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <p>
                            T4 Statements are created and issued at the end of February each year.
                            You can now access your T4 online and stop receiving a mailed paper T4 statement.
                            You will have the convenience to access them at any time once they are posted.
                        </p>

                        <table cellPadding="0" style={{ border: "0px" }}>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutT4Yes' name='optInOutT4' type='radio' radioGroup='optInOutT4' value='Y' defaultChecked={this.state.goGreenTaxDialog.optOut != 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I want to access my T4 Statement online only and opt out of receiving paper T4 Statement by mail.
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutT4No' name='optInOutT4' type='radio' radioGroup='optInOutT4' value='N' defaultChecked={this.state.goGreenTaxDialog.optOut === 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I prefer to continue receiving my paper T4 Statement by mail and I do not wish to access my T4 Statements online.*
                                </td>
                            </tr>
                        </table>
                        <p><em>
                            *If you change your mind, please return to this portal and click on Tax Statement icon to opt out of receiving paper T4 Statement by mail and get your T4 electronically online.
                        </em></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='pull-left' style={{ width: 150 }}
                            onClick={evt => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                                self.optInTaxStatement($('#optInOutT4Yes').prop("checked"));
                            }}>Submit</Button>
                        <Button className='pull-right' style={{ width: 150 }}
                            onClick={() => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                            }}>Cancel</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.goGreenTaxDialog.show && (this.state.country == "GBR")} backdrop='static'>
                    <Modal.Header>
                        <h3>P60 Statements - Go Paperless. <span style={colorGreen}>Go Green</span></h3>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <p>
                            When P60 are created and issued after the 5th of April each year,
                            you can now access your P60 statements online and stop receiving emailed P60 statement.
                            You will have the convenience to access them at any time once they are posted.
                        </p>

                        <table cellPadding="0" style={{ border: "0px" }}>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutP60Yes' name='optInOutP60' type='radio' radioGroup='optInOutP60' value='Y' defaultChecked={this.state.goGreenTaxDialog.optOut != 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I want to access my P60 statements online only and opt out of receiving P60 by email.
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    <input id='optInOutP60No' name='optInOutP60' type='radio' radioGroup='optInOutP60' value='N' defaultChecked={this.state.goGreenTaxDialog.optOut === 'N'} />
                                </td>
                                <td style={{ padding: 5, verticalAlign: "top" }}>
                                    I prefer to continue receiving paper P60 by email and I do not wish to access my P60 statements online.*
                                </td>
                            </tr>
                        </table>
                        <p><em>
                            *If you change your mind, please return to this portal, and click on Tax Statement icon to opt out of receiving P60 by email and get your P60 electronically online.
                        </em></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='pull-left' style={{ width: 150 }}
                            onClick={evt => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                                self.optInTaxStatement($('#optInOutP60Yes').prop("checked"));
                            }}>Submit</Button>
                        <Button className='pull-right' style={{ width: 150 }}
                            onClick={() => {
                                const newState = immutable.fromJS(self.state).toJS();
                                newState.goGreenTaxDialog.show = false;
                                self.setState(newState);
                            }}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}